import { motion } from "framer-motion";

const EASE = [0.22, 0.61, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.4, delay: i * 0.06, ease: EASE } }),
};

export const Reveal = ({ children, className = "", i = 0, as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M className={className} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}>
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <div className={className}>
    <div className="eyebrow">{children}</div>
    <div className="eyebrow-rule" />
  </div>
);
